module.exports = __webpack_public_path__ + "img/titleid.d56060c3.png";